import { render, staticRenderFns } from "./UploadFixedPricesFiles.vue?vue&type=template&id=6d74150f&scoped=true"
import script from "./UploadFixedPricesFiles.vue?vue&type=script&lang=ts"
export * from "./UploadFixedPricesFiles.vue?vue&type=script&lang=ts"
import style0 from "./UploadFixedPricesFiles.vue?vue&type=style&index=0&id=6d74150f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74150f",
  null
  
)

export default component.exports